import { render } from "./HeroiconsOutlineKey.vue?vue&type=template&id=6ff0cc63"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineKey.vue"]])

export default __exports__